import { createFromIconfontCN } from "@ant-design/icons";

const Icon = createFromIconfontCN({
  scriptUrl: "//at.alicdn.com/t/c/font_2430965_bvv26kwz5ke.js",
});

export default Icon;
